module.exports = __webpack_public_path__ + "img/rain.596dee7d.jpg";